import { render, staticRenderFns } from "./ed-portal-sidebar.vue?vue&type=template&id=872fa104&scoped=true&"
import script from "./ed-portal-sidebar.ts?vue&type=script&lang=js&"
export * from "./ed-portal-sidebar.ts?vue&type=script&lang=js&"
import style0 from "./ed-portal-sidebar.scss?vue&type=style&index=0&id=872fa104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872fa104",
  null
  
)

export default component.exports